import React, { useMemo } from "react"
import { Dropdown } from "react-bootstrap"
import { useTranslation } from "react-i18next"

const LanguageToggle = () => {
  const { i18n } = useTranslation("global")

  const languages = useMemo(
    () => [
      { code: "es_DO", name: "Español (DO)", flag: "🇩🇴" },
      { code: "en_US", name: "English (US)", flag: "🇺🇸" },
    ],
    []
  )

  const currentLanguage = useMemo(
    () => languages.find(lang => lang.code === i18n.language) || languages[0],
    [languages, i18n.language]
  )

  const changeLanguage = languageCode => {
    if (languageCode !== i18n.language) {
      i18n.changeLanguage(languageCode)
      localStorage.setItem("language", languageCode)
    }
  }

  return (
    <div className="language-toggle">
      <Dropdown align="end">
        <Dropdown.Toggle
          variant="outline-secondary"
          id="language-dropdown"
          size="sm"
          className="d-flex align-items-center"
        >
          <span className="me-2">{currentLanguage.flag}</span>
          <span className="d-none d-md-inline">{currentLanguage.name}</span>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {languages.map(language => (
            <Dropdown.Item
              key={language.code}
              active={i18n.language === language.code}
              onClick={() => changeLanguage(language.code)}
              className="d-flex align-items-center"
            >
              <span className="me-2">{language.flag}</span>
              <span>{language.name}</span>
              {i18n.language === language.code && (
                <i className="fas fa-check ms-auto text-success"></i>
              )}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}

export default LanguageToggle
